import React, { useEffect } from "react";
import "./uploadSingleBatchUser.css";
import { PageTitle } from "../../../../components/common";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";
import UploadSingleBatchUserForm from "../../components/upload-single-batch-user-form";
import { useDispatch, useSelector } from "react-redux";
import { getAllScoreCardsRiskFactorsByType } from "../../actions/getAllScoreCardsRiskFactorsByType";
import {
  selectAllScoreCardsRiskFactorsByType,
  selectAllScoreCardsRiskFactorsByTypeLoading,
  selectScoreCardCalculateLoading,
} from "../../selectors";
import { scoreCardCalculate } from "../../actions/scoreCardCalculateActions";
import { trimFormData } from "../../../../utilities/filters";
import { mainClientTypeSelector } from "../../../../selectors/getScoreCardByTypeSelectors";
import moment from "moment/moment";

const UploadSingleBatchUser = () => {
  const dispatch = useDispatch();
  const organizationName = localStorage.getItem("orgName");
  const isScoreCardsRiskFactorsLoading = useSelector(
    selectAllScoreCardsRiskFactorsByTypeLoading,
  );
  const isLoadingScoreCardCalculate = useSelector(
    selectScoreCardCalculateLoading,
  );
  const scoreCardsRiskFactors = useSelector(
    selectAllScoreCardsRiskFactorsByType,
  );

  const clientTypes = useSelector(mainClientTypeSelector);

  useEffect(() => {
    dispatch(getAllScoreCardsRiskFactorsByType());
  }, []);

  function convertKeyValue(clientParams) {
    if (!clientParams) {
      return {};
    }

    const tempClientParams = {...clientParams}

    if (tempClientParams["DateOfBirth"]) {
      const tempDateOfBirth = tempClientParams["DateOfBirth"];
      tempClientParams["DateOfBirth"] =
        moment(tempDateOfBirth).format("DD.MM.YYYY");
    }

    return Object.entries(tempClientParams).map(([key, value]) => ({
      name: key,
      value: value,
    }));
  }

  const handleSubmit = (data) => {
    const convertedClientParams = convertKeyValue(data.clientParams);
    const trimmedData = trimFormData({
      clients: [
        {
          organizationName,
          isActive: true,
          ...{ ...data, clientParams: convertedClientParams },
        },
      ],
      companyOfferId: data.companyOfferId,
    });

    dispatch(scoreCardCalculate(trimmedData));
  };

  return (
    <div>
      <PageTitle title="upload single api user" />
      <FullscreenLoader
        loading={isScoreCardsRiskFactorsLoading || isLoadingScoreCardCalculate}
      />
      <UploadSingleBatchUserForm
        clientTypes={clientTypes}
        handleSubmit={handleSubmit}
        scoreCardsRiskFactors={scoreCardsRiskFactors}
        isLoading={isLoadingScoreCardCalculate}
      />
    </div>
  );
};

export default UploadSingleBatchUser;



// WEBPACK FOOTER //
// ./src/features/score-card/pages/upload-single-batch-user/UploadSingleBatchUser.jsx